var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"absolute":"","flat":"","app":"","theme--dark":"","primary":"","elevation-6":""}},[_c('logo')],1),_c('header-image')],1)}
var staticRenderFns = []

export { render, staticRenderFns }